import { Attributes, List, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationLookup extends ModelBase {

    public organisationId: number = 0;

    public nominatedCurrencyId: number = 0;

    public organisationName: string = "";

}